import { render, staticRenderFns } from "./infoBox.vue?vue&type=template&id=12e78d82&scoped=true&lang=html&"
import script from "./infoBox.vue?vue&type=script&lang=js&"
export * from "./infoBox.vue?vue&type=script&lang=js&"
import style0 from "./infoBox.vue?vue&type=style&index=0&id=12e78d82&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e78d82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
